import settingsReducer from './settingsReducer';
import clientInfoReducer from './clientInfoReducer';
import businessCardReducer from './clientInfoReducer';

export {settingsReducer,clientInfoReducer,businessCardReducer};
export default businessCardReducer;
